/* eslint-disable complexity */
export function getErrorMessage(error, isDefaultError = true, isChinese = false) {
	const statusCode = error?.response?.status || 400

	if (statusCode === 401) {
		const errorMessage =
			error?.response?.data?.message || error?.response?.data?.errors || undefined

		if (errorMessage === 'INSUFFICIENT_TH_LEVEL') {
			return '/error/7'
		}

		if (errorMessage === 'PLAYER_BANNED') {
			return '/error/31'
		}

		if (errorMessage === 'INSUFFICIENT_ROLE') {
			return '/error/37'
		}
	}

	if (statusCode === 400) {
		const errorMessage = error?.response?.data?.errors || undefined

		if (errorMessage === 'INSUFFICIENT_PERMISSION') {
			return '/error/17'
		}

		if (errorMessage === 'INCOMPLETE_ROSTER') {
			return '/error/24'
		}

		if (errorMessage === 'INVALID_CLAN_LEVEL') {
			return '/error/32'
		}

		if (errorMessage === 'INCOMPLETE_CLAN') {
			return '/error/11'
		}

		if (errorMessage === 'TH_LEVELS_MISMATCH') {
			return '/error/27'
		}

		if (errorMessage === 'MEMBERS_MISSING') {
			return '/error/11'
		}

		if (errorMessage === 'Roster changes limit exceeded') {
			return '/error/35'
		}

		if (errorMessage === 'WRONG_MEMBER') {
			return '/error/36'
		}

		if (errorMessage === 'PLAYER_BANNED') {
			return '/error/31'
		}

		if (errorMessage === 'OPPONENT_IS_IN_WAR') {
			return isChinese ? '/error/19' : '/error/20'
		}

		if (errorMessage === 'CLAN_IS_IN_WAR') {
			return isChinese ? '/error/18' : '/error/14'
		}
	}

	if (isDefaultError) {
		return '/error'
	}

	return undefined
}
